<template>
  <div id="contenuAdmin">
    <MenuAdmin id="menuTop"/>
    <div id="main">
      <component :is="layout">
      </component>
    </div>
  </div>
</template>
<script>
import script from '../../script/script.js';
import MenuAdmin from './MenuAdmin.vue';
export default {
  data() {
    return {
		post: {},
    }
  },
  mounted:function(){
     this.verifyRight();
  },
  methods: {
	verifyRight: script.verifyRight,
  },
  components: {
    MenuAdmin
  },
  computed:{
    layout(){
      return(this.$route.meta.layout)+'-layout';
    }
  }
  
}
</script>
<style>
	#main{
		flex: 1 0 95%;
		transition: all .3s;
		position: absolute;
		top: 6%;
		left: 3%;
		right: 0;
		bottom: 0;
		max-height: 94%;
		overflow: auto;
	}

	.v-sidebar-menu-admin .collapse-btn{
		background-color:transparent;
		outline:none;
	}

	.v-sidebar-menu-admin .vsm-item.first-item.active-item>.vsm-link>.vsm-icon, .v-sidebar-menu-admin .vsm-item.first-item>.vsm-link>.vsm-icon{
		background-color:transparent;
	}

	.v-sidebar-menu-admin{
		max-width: 12vw;
		background-color:#808285;
		position: absolute;
		height: 94%;
		top: 6%;
	}

	.v-sidebar-menu-admin div:nth-child(2){
		max-width: 12vw;
	}

	.v-sidebar-menu-admin .vsm-link{
		font-size:13px;
	}

	#contenuAdmin{
		display: flex;
		height: 100%;
		flex-wrap: wrap;
	}

	#menuTop{
		flex: 1 0 100%;
		height: 6%;
	}
</style>
